export enum ChemicalOrderStatusEnum {
    Unsaved = 1,
    Draft = 2,
    SentToOperator = 3,
    Canceled = 4,
    Ordered = 5,
    Confirmed = 6,
}
